import { PayloadAction } from "@reduxjs/toolkit";

import { createSlice } from "@reduxjs/toolkit";

import { TemporaryMessage } from "../types";
import { LinkedInAttachment } from "interfaces/linkedin";
import { AttachmentMode, OutgoingAttachment } from "lib/linkedin";

export interface TemporarySlice {
    temporaryMessages: Record<string, TemporaryMessage[]>;
}

const initialState: TemporarySlice = {
    temporaryMessages: {},
}

export function convertToLinkedInAttachment(attachment: OutgoingAttachment, newMessageUUID: string): LinkedInAttachment {
    switch (attachment.mode) {
        case AttachmentMode.VOICE_MEMO:
            return {
                audio: {
                    assetUrn: `temp:${newMessageUUID}:${attachment.blob.type}`,
                    duration: 0,
                    url: URL.createObjectURL(attachment.blob),
                },
            }
        case AttachmentMode.FILE:
        default:
            return {
                file: {
                    assetUrn: `temp:${newMessageUUID}:${attachment.blob.name}`,
                    byteSize: attachment.blob.size,
                    mediaType: attachment.blob.type,
                    name: attachment.blob.name,
                    url: attachment.blob.type.startsWith('image/') ? URL.createObjectURL(attachment.blob) : `data:${attachment.blob.type};attachment,${attachment.blob.name}`,
                }
            }
    }
}

export const temporarySlice = createSlice({
    name: 'temporary',
    initialState,
    reducers: {
        addTemporaryMessage: (state, action: PayloadAction<{ conversationId: string, message: TemporaryMessage }>) => {
            if (!state.temporaryMessages[action.payload.conversationId]) {
                state.temporaryMessages[action.payload.conversationId] = [];
            }
            state.temporaryMessages[action.payload.conversationId].push(action.payload.message);
        },
        removeTemporaryMessage: (state, action: PayloadAction<{ conversationId: string, messageId: string }>) => {
            state.temporaryMessages[action.payload.conversationId] = state.temporaryMessages[action.payload.conversationId].filter(message => message.uuid !== action.payload.messageId);
        },
        updateTemporaryMessage: (state, action: PayloadAction<{ conversationId: string, messageId: string, update: Partial<TemporaryMessage> }>) => {
            state.temporaryMessages[action.payload.conversationId] = state.temporaryMessages[action.payload.conversationId].map(message => message.uuid === action.payload.messageId ? { ...message, ...action.payload.update } : message);
        },
    },
})

export const { addTemporaryMessage, removeTemporaryMessage, updateTemporaryMessage } = temporarySlice.actions;